export const COOKIE_TERMS_AND_CONDITIONS_NAME = 'BmCGUModalLastShown'
export const MINUTES_COUNTER_WITHOUT_MODAL_IN_MS = 10 * 60000
export const SIGNATURE_PARAM_VALUE = {
  DID_SIGN: 'OK',
  DID_NOT_SIGN: 'KO',
}
export const MODAL_NAME = 'TERMS_AND_CONDITIONS'
